import { AutoComplete, Button, Form, Modal, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { questionOptionsModalSliceDispatch, questionViewerSliceDispatch } from "../../Constants/ReduxConstants";

function QuestionOptionsModal({ disabled, adder, children }: { disabled: any; adder: any; children?: React.ReactNode }) {
    const open = useSelector((state: any) => state.questionOptionsModal.open);
    const valueToAdd = useSelector((state: any) => state.questionOptionsModal.valueToAdd);
    const optionToAdd = useSelector((state: any) => state.questionOptionsModal.optionToAdd);
    const allOptions = useSelector((state: any) => state.questionOptionsModal.allOptions);

    const questionToAdd = useSelector((state: any) => state.questionModal.questionToAdd);
    const currentQuestion = useSelector((state: any) => state.questionViewer.currentQuestion);

    const dispatch = useDispatch()

    const onSubmit = () => {
        //We are adding a new one
        if (adder) {
            adder(allOptions)
        }

        dispatch({ type: questionOptionsModalSliceDispatch.setOpen, payload: false })
    }

    const onCancel = () => {
        dispatch({ type: questionOptionsModalSliceDispatch.setOpen, payload: false })
    }

    const onValueChange = (event) => {
        dispatch({ type: questionOptionsModalSliceDispatch.setValueToAdd, payload: event.target.value })
    }

    const onOptionChange = (event) => {
        dispatch({ type: questionOptionsModalSliceDispatch.setOptionToAdd, payload: event.target.value })
    }

    const onOptionDelete = (deletingOption) => {

        let filteredValues = allOptions.filter(ao => ao.value !== deletingOption?.value &&
            ao.option !== deletingOption?.option)

        dispatch({ type: questionOptionsModalSliceDispatch.setAllOptions, payload: filteredValues })
    }

    const handleAddNew = () => {
        let itemToAdd = { "option": optionToAdd, "value": valueToAdd }
        let tempAdd = allOptions

        dispatch({ type: questionOptionsModalSliceDispatch.setAllOptions, payload: [...tempAdd, itemToAdd] })
    }

    const handleMoveUp = (e) => {
        let existing = allOptions;
        var temp = existing[e - 1];
        existing[e - 1] = existing[e];
        existing[e] = temp;

        dispatch({ type: questionOptionsModalSliceDispatch.setAllOptions, payload: [...existing] });
    }

    const handleMoveDown = (e) => {
        let existing = allOptions;
        var temp = existing[e + 1];
        existing[e + 1] = existing[e];
        existing[e] = temp;

        dispatch({ type: questionOptionsModalSliceDispatch.setAllOptions, payload: [...existing] });
    }

    let columns = [
        {
            title: 'Option',
            dataIndex: 'Option',
            key: 'Option',
            render: (text) => <p>{text}</p>
        },
        {
            title: 'Value',
            dataIndex: 'Value',
            key: 'Value',
            render: (text) => <p>{text}</p>
        },
        {
            title: 'Delete',
            dataIndex: 'Delete',
            key: 'Delete',
            render: (text) => <Button data-delete={text} onClick={() => onOptionDelete(text)}>Delete</Button>
        },
        {
            title: 'Move Down',
            dataIndex: 'MoveDown',
            key: 'MoveDown',
            render: (text) => <Button
               
                disabled={text == allOptions.length - 1}
                onClick={() => handleMoveDown(text)}>Move Down
            </Button>
        },
        {
            title: 'Move Up',
            dataIndex: 'MoveUp',
            key: 'MoveUp',
            render: (text) => <Button
               
                margin-right={'5px'}
                disabled={text == 0}
                onClick={() => handleMoveUp(text)}>Move Up
            </Button>
        }
    ]

    let data = allOptions.map((option, optionIndex) => {
        return {
            Option: option.option,
            Value: option.value,
            key: optionIndex,
            Delete: option,
            MoveUp: optionIndex,
            MoveDown: optionIndex,
            DefaultValue: currentQuestion.defaultValue
        }
    })

    const defaultValueChanged = (event) => {
        currentQuestion.defaultValue = event;
        dispatch({ type: questionViewerSliceDispatch.setCurrentQuestion, payload: currentQuestion });
    }

    let tableRows = <Table columns={columns} dataSource={data} pagination={false} />

    let addButton = <Button data-delete="fake" onClick={() => handleAddNew()} >Add</Button>

    return open ? (
        <Modal
            title="Options"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
        >
            <input id="option" defaultValue={optionToAdd} placeholder="Display" onChange={(event) => onOptionChange(event)} />
            <input id="value" placeholder="Value" defaultValue={valueToAdd} onChange={(event) => onValueChange(event)} />
            <Form
                onFinish={onSubmit}
                onFinishFailed={onCancel}
                preserve={false}
            >
                {addButton}
                <Form.Item name="Default Value" label="Default Value">
                    <AutoComplete
                        id="defaultValue"
                        placeholder='Default Value'
                        dropdownMatchSelectWidth={true}
                        options={data.map(k => ({ label: k.Option, value: k.Value }))}
                        defaultValue={data.filter(x => x.Value == questionToAdd.defaultValue)[0]?.Option}
                        onChange={defaultValueChanged}
                    />
                </Form.Item>
                <div style={{ overflow: 'auto' }}>
                    {tableRows}
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    ) : (
        <Button disabled={disabled} onClick={() => {
            let initialOptions = questionToAdd?.options?.map((currentOption, currentOptionIndex) => {
                return {
                    option: questionToAdd?.options[currentOptionIndex],
                    value: questionToAdd?.values[currentOptionIndex]
                }
            })

            dispatch({ type: questionOptionsModalSliceDispatch.setAllOptions, payload: initialOptions });
            dispatch({ type: questionOptionsModalSliceDispatch.setOpen, payload: true });
        }}>Edit Options</Button>
    )
}

export default QuestionOptionsModal;